module.exports = __webpack_public_path__ + "img/bg5.7783a193.png";